export default __webpack_public_path__ + "static/media/GRHP7 7A-4EC.df040aa0.jpg";